import footerConfig from "@/data/components/footer.json";
import { deepMerge } from "@/utils/deepMerge";
import type { ComponentRef, SectionConfig } from "./types";

type VariantMap = Record<string, SectionConfig>;

const componentConfigs: Record<string, VariantMap> = {
  footer: footerConfig as unknown as VariantMap,
};

export function resolveComponentRef(ref: ComponentRef): SectionConfig | null {
  const config = componentConfigs[ref.$ref];

  if (!config) {
    return null;
  }

  const availableVariants = Object.keys(config);
  const variant = ref.variant || availableVariants[0];
  const resolvedComponent = config[variant];

  if (!resolvedComponent) {
    return null;
  }

  if (ref.props && resolvedComponent.props) {
    return {
      ...resolvedComponent,
      props: deepMerge({ ...resolvedComponent.props }, ref.props),
    };
  }

  return resolvedComponent;
}
